const modules = import.meta.glob<{ default: string }>('./zdiby-*.jpg', { eager: true });

export const zdibyImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/zdiby-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/zdiby-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);
